import React from 'react'

import type { NextPage } from 'next'

import { loanOnline } from 'data/seo'
import LoanOnline from 'views/loan-online'

const LoanOnlinePage: NextPage = () => <LoanOnline />

export default LoanOnlinePage

export async function getStaticProps() {
  return {
    props: { SEO: loanOnline }
  }
}
